<template>
  <section>
    <v-btn color="primary" dark @click.stop="dialog = true">
      Adicionar Porte Estudo Ambiental
    </v-btn>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Adicionar Porte Estudo Ambiental
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-text-field
              v-model="typologySize.min"
              :rules="requiredRules"
              label="Valor Mínimo"
              required></v-text-field>
            <v-text-field
              v-model="typologySize.max"
              :rules="requiredRules"
              label="Valor Máximo"
              required></v-text-field>
            <v-select
              v-model="typologySize.enviromental_study_type_id"
              :hint="'Selecione um Tipo de Estudo Ambiental'"
              :items="enviromentalStudyTypes"
              item-text="name"
              item-value="id"
              single-line
              label="Tipo de Estudo Ambiental"></v-select>
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">Cancelar</v-btn>
          <v-btn color="primary" flat @click="createTypologySize">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>

import EnviromentalStudyType from '@/services/applications/configurations/EnviromentalStudyTypeService';
import TypologySizeService from '@/services/applications/configurations/TypologySizeService';

export default {
  name: 'CreateTypologySize',
  components: {},
  props: ['typologyId'],
  mounted() {
    EnviromentalStudyType
      .fetchEnviromentalStudyTypes()
      .then((response) => {
        this.enviromentalStudyTypes = response.data;
      });
  },
  data() {
    return {
      requiredRules: [
        v => !!v || 'Campo Obrigatório',
      ],
      dialog: false,
      valid: false,
      typologySize: {},
      enviromentalStudyTypes: [],
    };
  },
  methods: {
    createTypologySize() {
      const vm = this;

      TypologySizeService
        .createTypologySize(vm.typologyId, vm.typologySize)
        .then((response) => {
          vm.$swal({
            title: 'Porte Cadastro com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.typologySize = {};
            vm.$emit('create-size', response.data);
            vm.dialog = false;
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
